var React = require('react');

function ApiReference (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .cls-1{fill:#001b35}\n    ")),React.createElement("path",{"className":"cls-1","d":"M13.28 18.17c1.34-.05 2.38-.89 2.23-2.14l-.23-1.75A2 2 0 0117.07 12a2 2 0 01-1.79-2.31l.23-1.75c.15-1.23-.89-2-2.23-2.07V4c3.5 0 5.77 1.11 5.3 4l-.26 1.46a1.15 1.15 0 001.08 1.41.75.75 0 01.6.76v.74a.77.77 0 01-.6.77 1.16 1.16 0 00-1.08 1.42l.26 1.44c.47 2.77-1.8 4-5.3 4zM10.72 18.17c-1.34-.05-2.38-.89-2.23-2.14l.23-1.75A2 2 0 006.93 12a2 2 0 001.79-2.35L8.49 7.9c-.15-1.23.89-2 2.23-2.07V4C7.22 4 5 5.09 5.42 8l.26 1.46a1.15 1.15 0 01-1.08 1.39.75.75 0 00-.6.76v.74a.77.77 0 00.6.77 1.16 1.16 0 011.08 1.42L5.42 16c-.47 2.77 1.8 4 5.3 4z","key":1})]);
}

ApiReference.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 24 24"};

module.exports = ApiReference;

ApiReference.default = ApiReference;
